import { render, staticRenderFns } from "./CaMan.vue?vue&type=template&id=3a56624d&scoped=true&"
import script from "./CaMan.vue?vue&type=script&lang=js&"
export * from "./CaMan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a56624d",
  null
  
)

export default component.exports